import { ForwardRefRenderFunction, forwardRef } from 'react';
import styles from './DistrictsMap.css';

const DistrictsMapComponent: ForwardRefRenderFunction<HTMLDivElement> = (_, ref) => {
  return <div ref={ref} className={styles['map']} />;
};

export const RegionalDistrictsMap = forwardRef<HTMLDivElement>(DistrictsMapComponent);
